




































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { LineLayer } from "@/model/document2/page/surface/design/layer/lineLayer";
import { CurveLayer } from "@/model/document2/page/surface/design/layer/curveLayer";

import { ColorConstruct } from "@/utilityModels/colorConstruct";

import LineStrokeWidthController from "./lineStrokeWidthController/lineStrokeWidthController.vue";
import LineStrokeColorController from "./lineStrokeColorController/lineStrokeColorController.vue";
import LineOpacityController from "./lineOpacityController/lineOpacityController.vue";
import LineStrokeTypeController from "./lineStrokeTypeController/lineStrokeTypeController.vue";
import LineStartController from "./lineStartController/lineStartController.vue";
import LineEndController from "./lineEndController/lineEndController.vue";

@Component({
    components: {
        LineStrokeWidthController,
        LineStrokeColorController,
        LineOpacityController,
        LineStrokeTypeController,
        LineStartController,
        LineEndController
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class LineController extends Vue 
{
    @Prop() layer! : LineLayer | CurveLayer;

    private lineControllerType = "lineStrokeWidth";

    private isActive(type)
    {
        return this.lineControllerType == type;
    }

    private changeType(type : string)
    {
        this.lineControllerType = type;
    }

    private onChangeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {   
        this.$emit("doCommand", "changeLayerProperty", {  
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private onRequestColor(propertyName : string, currentValue : ColorConstruct)
    {
        var parameter = {};
        parameter["propertyName"] = propertyName;
        parameter["type"] = "color";
        var hex = currentValue.hex;
        if(hex.substr(0, 1) == "#") { hex = hex.substr(1, 6); }
        parameter["currentValue"] = hex;
        this.$emit("doCommand", "sendNativeEvent", {
            message : "request_layer_property",
            parameter : parameter
        });
    }
}
